// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.lmProductDetail = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			$productGallery: $('.product-gallery'),
			$productGalleryImages: $('.product-gallery-images'),
			productGalleryImages: '.product-gallery-images',
			$productGalleryThumbnails: $('.product-gallery-thumbnails'),
			productGalleryThumbnails: '.product-gallery-thumbnails',
			$productGalleryThumbnailsItem: $('.product-gallery-thumbnails__item'),
			productGalleryThumbnailsItem: '.product-gallery-thumbnails__item',
			productGalleryImagesItemVideo: 'product-gallery-images__item--video',
			$productFeature: $('.product-feature'),
			$productFeatureDetails: $('.product-feature-details'),
			$productFeatureDetailItem: $('.product-feature-details__item'),
			productFeatureDetailItem: '.product-feature-details__item',
			$productFeatureImages: $('.product-feature-images'),
			productFeatureImages: '.product-feature-images',
			slickDots: '.slick-dots',
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		};

		// Toggle Active Classes
		methods.activateProductGalleryItem = function($this) {
			var slickIndex = $this.attr('data-slick-index'),
				slickCurrentSlide = settings.$productGalleryThumbnails.slick('slickCurrentSlide');
			if (slickIndex != slickCurrentSlide) {
				settings.$productGalleryImages.slick('slickGoTo', slickIndex);
				settings.$productGalleryThumbnails.slick('slickGoTo', slickIndex);
			}
		};

		// Toggle Active Classes
		methods.activateProductFeatureDetailItem = function($this) {
			var slickIndex = $this.attr('data-slick-index'),
				slickCurrentSlide = settings.$productFeatureImages.slick('slickCurrentSlide');
			if (slickIndex != slickCurrentSlide) {
				settings.$productFeatureImages.slick('slickGoTo', slickIndex);
				settings.$productFeatureDetails.slick('slickGoTo', slickIndex);
			}
		};

		// Bind events
		methods.events = function() {
			// On click of product gallery thumbnail
			settings.$productGallery.off('click.lmGlobal').on('click.lmGlobal', settings.productGalleryThumbnailsItem, function(event) {
				event.preventDefault();
				var $this = $(this);
				methods.activateProductGalleryItem($this);
			});
			// On click of product feature detail
			settings.$productFeature.off('click.lmGlobal').on('click.lmGlobal', settings.productFeatureDetailItem, function(event) {
				event.stopImmediatePropagation();
				var $this = $(this);
				methods.activateProductFeatureDetailItem($this);
			});
		};

		// On load function.
		methods.initContext = function() {

			methods.setCurrentSettings();
			// On product Gallery Images init
			settings.$productGalleryImages.on('init', function() {
				var $this = $(this),
					$videoSlides = $this.find('.' + settings.productGalleryImagesItemVideo),
					$slickDots = settings.$productGallery.find(settings.slickDots);

				// If some slides have video
				if ($videoSlides.length) {
					// Loop through the dots
					$videoSlides.each(function() {
						var $this = $(this),
							slideIndex = $this.attr('data-slick-index'),
							$slideDot = $slickDots.find('li').eq(slideIndex);

						// Add the class of video to the slide dot
						$slideDot.addClass('video');
					});
				}
			});

			// Before Slide Change event on main product galery
			settings.$productGalleryImages.on('beforeChange', function(event, slick, nextSlide) {
				var $currentSlide = settings.$productGalleryImages.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
				// If this slide has a video
				if ($currentSlide.hasClass(settings.productGalleryImagesItemVideo)) {
					// Pause the video
					$currentSlide.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
				}
			});

			// After Slide Change event on main product galery
			// TODO: leaving this commented out for now until confirmation that it's needed
			//settings.$productGalleryImages.on('afterChange', function(event, slick, currentSlide) {
			//var $currentSlide = settings.$productGalleryImages.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
			// // If this slide has a video
			// if ($currentSlide.hasClass(settings.productGalleryImagesItemVideo)) {
			// 	// Play the video
			// 	$currentSlide.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
			// }
			//});
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});

	};

	if ($('.product-gallery').length) {
		$('.product-gallery').lmProductDetail();
	}

}(jQuery));
